import { useEffect } from 'react';

import { useHandleTransaction } from '../hooks/useHandleTransaction';

import { PayInInstallments } from './PayInInstallments';
import { PayInOneInstallments } from './PayInOneInstallment';

import { Button, Loader, Modal, Tags } from '@/components';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import usePinsAccount from '@/hooks/usePinsAccount';
import { PropsWithClassName } from '@/types';
import { CardKey, CONF_TARJETAS } from '@/utils';

const classButtonTag =
  'lg:flex w-full text-left lg:justify-center h-[46px] text-sm lg:text-gdt-blue text-gdt-gray-2 border-gdt-gray-xl2 flex items-center p-0 mt-2';

export const PaymentCardSelector = ({ className }: PropsWithClassName) => {
  const { pinsData, updatePinsData } = usePinsAccount();
  const { isMobile } = useIsDesktop();
  const { handleTransactionValidation } = useHandleTransaction();

  useEffect(() => {
    updatePinsData({
      showModalPayInInstallments: false,
      showModalPayInOneInstallment: false,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isMobile && <Loader isVisible={pinsData.loadingTokenized} />}
      <div className={`flex flex-col justify-between flex-1 ${className}`}>
        <div>
          <p className="font-medium text-center">Seleccioná tu tarjeta</p>
          {(Object.keys(CONF_TARJETAS) as CardKey[]).map((cardType) => {
            const card = CONF_TARJETAS[cardType];
            return (
              <Tags.Checkbox
                key={card.id}
                className={classButtonTag}
                isChecked={pinsData.selectedCard === cardType}
                onClick={() =>
                  updatePinsData({
                    selectedCard:
                      pinsData.selectedCard === cardType ? undefined : cardType,
                  })
                }
              >
                <figure className="w-14 lg:-ml-7 flex justify-center">
                  <img
                    alt={card.nombre}
                    className="w-auto h-6 mr-2 rounded-full"
                    src={`/./assets/images/${card.img}`}
                  />
                </figure>
                <span>{card.nombre}</span>
              </Tags.Checkbox>
            );
          })}
        </div>
        <Button
          className="mt-10 w-full md:w-3/4 mx-auto"
          disabled={
            !pinsData.selectedCard ||
            pinsData?.statusTransaction?.status === 'error'
          }
          type="button"
          variant="primary"
          onClick={() =>
            pinsData.selectedCard &&
            handleTransactionValidation(pinsData.selectedCard)
          }
        >
          Continuar
        </Button>
        {isMobile && (
          <>
            <Modal
              controlledOnClose={() => {
                updatePinsData({
                  statusTransaction: { status: null, msg: undefined },
                });
              }}
              isControlledOpen={pinsData?.statusTransaction?.status === 'error'}
              render={() => {
                return (
                  <>
                    <p>
                      <br />
                      {pinsData?.statusTransaction?.msg}
                    </p>
                    <div className="flex  space-x-2 mt-10">
                      <Button
                        className="flex-1"
                        type="button"
                        variant="secondary"
                        onClick={() => {
                          updatePinsData({
                            selectedCard: undefined,
                            showModalWallet: false,
                            showPaymentModalMethod: false,
                            showWalletLoadModal: false,
                            moneyToWallet: undefined,
                            statusTransaction: { status: null, msg: undefined },
                          });
                        }}
                      >
                        Cancelar
                      </Button>
                      <Button
                        className="flex-1"
                        type="button"
                        variant="primary"
                        onClick={() => {
                          return (
                            pinsData.selectedCard &&
                            handleTransactionValidation(
                              pinsData.selectedCard,
                              true
                            )
                          );
                        }}
                      >
                        Aceptar
                      </Button>
                    </div>
                  </>
                );
              }}
              size="xs"
              title="Atención"
              variant="controlled"
            />
            <Modal
              bottomSheetClassName="bg-gdt-gray-7 h-auto"
              className="bg-gdt-gray-7"
              controlledOnClose={() => {
                updatePinsData({
                  showModalPayInInstallments: false,
                  statusTransaction: { status: null, msg: undefined },
                  showPaymentModalMethod: true,
                  tokenizedCard: undefined,
                  responseTokenizedCards: undefined,
                });
              }}
              headerSheetClassName="rounded-t-lg !bg-gdt-gray-7"
              isControlledOpen={Boolean(pinsData.showModalPayInInstallments)}
              render={() => (
                <PayInInstallments
                  handleContinue={() =>
                    pinsData.selectedCard &&
                    handleTransactionValidation(pinsData.selectedCard, true)
                  }
                  selectedCard={pinsData.selectedCard ?? 'CREDITO'}
                />
              )}
              size="xs"
              title={CONF_TARJETAS[pinsData.selectedCard ?? 'CREDITO'].nombre}
              variant="controlled"
            />
            <Modal
              bottomSheetClassName="bg-gdt-gray-7"
              className="bg-gdt-gray-7"
              controlledOnClose={() => {
                updatePinsData({
                  showModalPayInOneInstallment: false,
                  statusTransaction: { status: null, msg: undefined },
                  showPaymentModalMethod: true,
                  tokenizedCard: undefined,
                  responseTokenizedCards: undefined,
                });
              }}
              headerSheetClassName="rounded-t-lg bg-gdt-gray-7"
              isControlledOpen={Boolean(pinsData.showModalPayInOneInstallment)}
              render={() => (
                <PayInOneInstallments
                  handleContinue={() =>
                    pinsData.selectedCard &&
                    handleTransactionValidation(pinsData.selectedCard, true)
                  }
                  selectedCard={pinsData.selectedCard || 'CREDITO'}
                />
              )}
              size="xs"
              title={CONF_TARJETAS[pinsData.selectedCard ?? 'CREDITO'].nombre}
              variant="controlled"
            />
          </>
        )}
      </div>
    </>
  );
};
